<template lang="pug">
.cp-talk-list
  .bg
    .list-wrap.w
      .item-wrap(v-for="(v, index) in list", :key="index")
        .content-wrap
          img.logo(:src="v.logo")
          p.label {{ v.label }}
          //- p.name {{ v.name }}
          p.text(v-if="{ showText: index === activeIndex }") {{ v.text }}
        .bottom-wrap
          .plantform
          .bottom-shadow
          img.bottomPic(:src="v.bottomPic")
          .light
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      isShow: false,
      activeIndex: -1,
      list: [
        {
          logo: require('@/assets/pufa.png'),
          label: '渠道合作部',
          name: '丁女士',
          text: '浦发银行采用去电智能营销服务，对潜在目标客户进行意向判断并做空中转化。较原有人工坐席模式，呼叫的意向客户成功率提升40%以上，客户投诉率下降21.7%。同时日触达客户规模明显提高。',
          bottomPic: require('@/assets/yixiang.png')
        },
        {
          logo: require('@/assets/shenzhou.png'),
          label: '电销中心',
          name: '付女士',
          text: '神州易桥通过去电对代理记账和纳税申报的客户做通知提醒，通知到达率从63%直线上升到了79.4%。大量的往复沟通及重复工作被AI所取代，客服工作效率直接提升50%以上，对客服团队的人数做了有效控制。',
          bottomPic: require('@/assets/tongzhi.png')
        },
        {
          logo: require('@/assets/youdemai.png'),
          label: '3c数码回收中心',
          name: '王先生',
          text: '有得卖电子产品回收业务，引入去电电商解决方案。用户下单后自动回访，订单确认报告同步生成，核验结果一目了然。每日人工外呼和数据记录的工作量下降70%以上，对客服压力做有效缓解，客户满意度直线上升。',
          bottomPic: require('@/assets/yewu.png')
        },
        {
          logo: require('@/assets/dianxin.png'),
          label: '政企客户部',
          name: '罗经理',
          text: '中国电信作为中国三大运营商之一，我们吉林分公司客服团队接入去电产品，采用AI坐席作为一线、人工作为二线坐席的模式，人均能效提升67%，有效减少了简单的复合人工作业。',
          bottomPic: require('@/assets/shouhou.png')
        },
        {
          logo: require('@/assets/huanbei.png'),
          label: '市场中心',
          name: '张先生',
          text: '去电智能营销平台根据还呗业务需求，为我们量身打造一体化营销服务。沉默用户激活周期明显缩短，活动通知触达及转化效率显著提升。同时去电采用智能化语音客服方案来替代传统的客服中心，有效缓解了客服压力并增加了业务转化。',
          bottomPic: require('@/assets/yitifuwu.png')
        },
      ]
    }
  },
  computed: {},
  methods: {
  }
}
</script>
<style lang="stylus">
$line-height1 = 118px
$line-height2 = 275px
$left-base = 20px
$left-offset = 215px
.cp-talk-list
  .bg
    height 810px
    margin 0 auto
    background-image url('../../../assets/kehushuo-bg.png')
    background-size 100%
    background-position bottom
    background-repeat no-repeat, no-repeat, no-repeat
    .list-wrap
      margin-top 93px
      height 100%
      position relative
      background-image url('../../../assets/robot1.png'), url('../../../assets/robot2.png')
      background-size 117px 194px, 77px 182px
      background-position 0px 500px, 650px 200px
      background-repeat no-repeat, no-repeat
      .item-wrap
        position absolute
        width 200px
        &:hover
          z-index 10
          &:nth-child(1) .content-wrap
            height 303px
          &:nth-child(2) .content-wrap
            height 335px
          &:nth-child(3) .content-wrap
            height 310px
          &:nth-child(4) .content-wrap
            height 280px
          &:nth-child(5) .content-wrap
            height 328px
          .content-wrap
            background url(../../../assets/flag.png)
            background-size 100% 100%
            z-index 4
            padding-top 20px
            &:before
              opacity 0
            .text
              transform translateY(20px)
              opacity 1
          .bottom-wrap
            .shadow
              opacity 1
            .light
              height 210px
            .bottom-shadow
              filter brightness(0.4)
        .content-wrap
          position absolute
          left 95px
          bottom -203px
          z-index 5
          width 210px
          height 230px
          padding 20px 20px 30px
          transition all 0.3s ease-out
          &::before
            content ''
            display block
            position absolute
            left 0
            bottom 0
            transition all 0.3s ease-out
            width 1px
            height 100%
            background-image linear-gradient(to top, #44C0CD 0%, #44C0CD 50%, transparent 50%)
            background-size 1px 20px
            background-repeat repeat-y
          .flag
            width 100%
            height 120%
            position absolute
            left 0px
            bottom 0px
            z-index 0
          .logo
            margin-bottom 5px
            transition all 0.3s ease-out
          .label
            font-size 16px
            transition all 0.3s ease-out
          .name
            font-size 19px
            font-weight 600
            transition all 0.3s ease-out
          .text
            font-size 14px
            line-height 1.7
            color #9EEAFA
            opacity 0
            transform translateY(-30px)
            transition all 0.3s ease-out
        .bottom-wrap
          position absolute
          top 203px
          left 0px
          width 189px
          height 150px
          .plantform
            position absolute
            top 0
            width 189px
            height 135px
            background url('../../../assets/zhantai.png') center / 100% no-repeat
            z-index 2
          .bottom-shadow
            position absolute
            top 40px
            width 189px
            height 125px
            background url('../../../assets/daoying.png') center / 100% no-repeat
            z-index 1
            transition all .3s
          .shadow
            position absolute
            top 55px
            left 8px
            width 173px
            height 116px
            background url('../../../assets/yinying.png') center / 100% no-repeat
          .bottomPic
            position absolute
            z-index 3
            width 88px
            height 98px
          .light
            position absolute
            left -12px
            bottom 40px
            width 219px
            height 0px
            background url('../../../assets/light.png') bottom / 100% no-repeat
            transition height .3s
          .showLight
            height 210px
        &:first-child
          top $line-height1
          left $left-base
          .logo
            width 90px
            height 26px
          .bottomPic
            left 20px
            top -6px
        &:nth-child(2)
          top $line-height2
          left $left-base + $left-offset
          .logo
            height 56px
          .bottomPic
            left 80px
            top 0px
        &:nth-child(3)
          top $line-height1
          left $left-base + 2 * $left-offset
          .logo
            width 90px
            height 34px
          .bottomPic
            left 20px
            top -6px
        &:nth-child(4)
          top $line-height2
          left $left-base + 3 * $left-offset
          .logo
            width 89px
            height 25px
          .bottomPic
            left 80px
            top 0px
        &:nth-child(5)
          top $line-height1
          left $left-base + 4 * $left-offset
          .logo
            width 29px
            height 28px
          .bottomPic
            left 20px
            top -6px
</style>
